import { CommonModule } from '@angular/common';
import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { ReplyConfig, REQUEST_TYPE, RoleRequisition } from '../../_core/approvals-page.model';
import { BehaviorSubject } from 'rxjs';
import { AlertComponent } from '../../../../../components/alert/alert.component';
import { LocalLoaderComponent } from '../../../../../components/loader/local-loader/local-loader.component';
import { ModalRequestDetailsBaseComponent } from '../_modal-request-details-base/modal-request-details-base.component';
import { ModalRequestActionsComponent } from '../_modal-request-actions/modal-request-actions.component';
import { FormBuilder, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { ToasterService } from '../../../../../components/toaster/toaster.service';
import { ModalService } from '../../../../../components/modal-list/modal-list.service';
import { ApprovalsPageService } from '../../_core/approvals-page.service';
import { CustomValidatorService } from '../../../../../components/form-elements/custom-validator.service';
import { FormErrorsModule } from '@spartacus/storefront';
import { I18nModule } from '@spartacus/core';

@Component({
  selector: 'modal-role-details',
  standalone: true,
  imports: [
    CommonModule,
    AlertComponent,
    I18nModule,
    LocalLoaderComponent,
    ModalRequestActionsComponent,
    ReactiveFormsModule,
    FormErrorsModule,
    I18nModule,
  ],
  templateUrl: './modal-role-details.component.html',
  styleUrl: './modal-role-details.component.scss',
})
export class ModalRoleDetailsComponent extends ModalRequestDetailsBaseComponent implements OnInit {
  roleRequisition$ = new BehaviorSubject<RoleRequisition>({});
  replyConfig: ReplyConfig = {
    type: REQUEST_TYPE.ROLE,
  };

  form: FormGroup = this.fb.group({
    Iagree: ['', [this.customValidatorService.required(), Validators.requiredTrue]],
  });

  constructor(
    protected _toasterService: ToasterService,
    protected _modalService: ModalService,
    protected _approvalsPageService: ApprovalsPageService,
    protected _cdr: ChangeDetectorRef,
    private fb: FormBuilder,
    private customValidatorService: CustomValidatorService,
  ) {
    super(_toasterService, _modalService, _approvalsPageService, _cdr);
  }

  override ngOnInit(): void {
    super.ngOnInit();
    this.getRoleRequisition();
  }

  getRoleRequisition() {
    this.subscription.add(
      this.requisitionDetailsRequest$.subscribe(response => {
        this.roleRequisition$.next(response.roleRequest || {});
      }),
    );
  }

  validation(): boolean {
    this.form.markAllAsTouched();
    return this.form.valid;
  }
}
